import {Directive, AfterViewInit, ElementRef} from '@angular/core';

@Directive({selector: '[focus-after-view-init]'})
export class FocusAfterViewInit implements AfterViewInit {
  constructor(public element: ElementRef) {}

  ngAfterViewInit() {
    this.element.nativeElement.focus();
  }
}
